import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=0874d1b5&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=0874d1b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874d1b5",
  null
  
)

export default component.exports